import Vue from 'vue';
import './bootstrap';
new Vue(); // eslint-disable-line no-new
/**
 *
 */
function getRandomInt(min, max) {
    var cMin = Math.ceil(min);
    var cMax = Math.floor(max);
    return Math.floor(Math.random() * (cMax - cMin + 1)) + cMin;
}
var cursorBlocks = document.querySelectorAll('.cursor-text');
if (cursorBlocks.length) {
    var cursor_1 = document.createElement('span');
    cursor_1.classList.add('cursor');
    var initializeBlocks = function () {
        for (var i = 0; i < cursorBlocks.length; i += 1) {
            var item = cursorBlocks[i];
            if (item instanceof HTMLElement) {
                var textContent = item.innerText;
                item.innerHTML = '';
                item.dataset.original = textContent;
                if (i === 0) {
                    item.appendChild(cursor_1);
                }
            }
        }
        var splashContent = document.querySelector('.homepage__splash__content');
        if (splashContent instanceof HTMLElement) {
            splashContent.classList.add('in');
        }
    };
    initializeBlocks();
    /**
     *
     */
    var playLetter_1 = function (letter) { return new Promise(function (resolve) {
        setTimeout(function () {
            var textNode = document.createTextNode(letter);
            if (cursor_1.parentNode instanceof HTMLElement) {
                cursor_1.parentNode.insertBefore(textNode, cursor_1);
            }
            resolve();
        }, getRandomInt(50, 75));
    }); };
    /**
     *
     */
    var loopLetters_1 = function (letters, i) { return new Promise(function (resolve) {
        if (i === letters.length) {
            resolve();
            return;
        }
        var item = letters[i];
        playLetter_1(item).then(function () { return loopLetters_1(letters, i + 1).then(function () {
            resolve();
        }); });
    }); };
    /**
     *
     */
    var playBlock_1 = function (node, textContent) {
        var delayElement = parseInt(node.dataset.delay, 10);
        var initialDelay = !Number.isNaN(delayElement) ? delayElement : 500;
        return new Promise(function (resolve) {
            node.appendChild(cursor_1);
            setTimeout(function () {
                loopLetters_1(textContent, 0).then(function () {
                    resolve();
                });
            }, initialDelay);
        });
    };
    /**
     *
     */
    var loopBlock_1 = function (i) {
        if (i === cursorBlocks.length) {
            setTimeout(function () {
                cursor_1.style.visibility = 'hidden';
            }, 750);
            return;
        }
        var item = cursorBlocks[i];
        var textContent = item instanceof HTMLElement ? item.dataset.original : '';
        playBlock_1(item, textContent).then(function () {
            loopBlock_1(i + 1);
        });
    };
    /**
     *
     */
    window.addEventListener('load', function () {
        loopBlock_1(0);
    });
}
